import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { Toaster } from "sonner"
import { AuthProvider } from "@/auth"
import { MainLayout } from "@/components/layout"
import {
  DashboardPage,
  EmployeesPage,
  EmployeeDetailPage,
  AttendancePage,
  ShiftPlanPage,
  AbsencesPage,
  VacationPage,
  TrainingsPage,
  ExaminationsPage,
  OrganizationPage,
  DocumentsPage,
  CompanyCalendarPage,
  DokumentationPage,
  AdminMasterDataPage,
} from "@/pages"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, "")}>
        {/* AuthProvider: dev = direkt durchreichen, logto = Login-Gate + /callback */}
        <AuthProvider>
          <Routes>
            <Route element={<MainLayout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/mitarbeiter" element={<EmployeesPage />} />
              <Route path="/mitarbeiter/:id" element={<EmployeeDetailPage />} />
              <Route path="/anwesenheit" element={<AttendancePage />} />
              <Route path="/schichtplan" element={<ShiftPlanPage />} />
              <Route path="/abwesenheiten" element={<AbsencesPage />} />
              <Route path="/urlaub" element={<VacationPage />} />
              <Route path="/schulungen" element={<TrainingsPage />} />
              <Route path="/vorsorge" element={<ExaminationsPage />} />
              <Route path="/organisation" element={<OrganizationPage />} />
              <Route path="/dokumente" element={<DocumentsPage />} />
              <Route path="/betriebskalender" element={<CompanyCalendarPage />} />
              <Route path="/dokumentation" element={<DokumentationPage />} />
              <Route path="/admin/stammdaten" element={<AdminMasterDataPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </QueryClientProvider>
  )
}
